import type { UniqueRouteKey } from "../types";
export const getNewUniqueRouteKey = (() => {
  let id = 0;
  return (prefix = "") => `${prefix}_${id++}` as UniqueRouteKey;
})();
